import "./Footer.css";
import React, { useState } from "react";
import axios from "axios";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [contactPopup, setContactPopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });

  const showContactPopup = ({ type = "info", title = "", message = "" }) => {
    setContactPopup({
      show: true,
      type,
      title,
      message,
    });
  };

  const closeContactPopup = () => {
    setContactPopup({
      show: false,
      type: "",
      title: "",
      message: "",
    });
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      showContactPopup({
        type: "error",
        title: "Failed to send email.",
        message: "Please enter an email address before sending.",
      });
      return;
    }

    try {
      await axios.post("/contactus/v1", {
        email,
      });

      showContactPopup({
        type: "success",
        title: "ส่งอีเมลสำเร็จ",
        message: "Email sent successfully!",
      });

      setEmail("");
    } catch (error) {
      console.error("Error sending email:", error);

      showContactPopup({
        type: "error",
        title: "เกิดข้อผิดพลาด",
        message: "Failed to send email.",
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-section contact">
        <h3>GET IN TOUCH</h3>
        <p>
          Join our mailing list to stay up to date and get notices about our new
          releases!
        </p>
        <div>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="mail@example.com"
            />
            <button type="submit" className="contact-submit-btn">
              Send
            </button>
          </form>
        </div>
      </div>
      <div className="footer-section follow-us">
        <h3>FOLLOW US</h3>
        <div className="social-icons1">
          <a
            href="https://www.facebook.com/proscopeit/"
            className="icon facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            f
          </a>
          <a
            href="https://www.linkedin.com/company/proscope-co.-ltd"
            className="icon linkedin"
            target="_blank"
            rel="noopener noreferrer"
          >
            in
          </a>
        </div>
      </div>

      <div className="footer-section company-info">
        <h3>PROSCOPE</h3>
        <p>
          Please feel free to contact us anytime if you are interested in our
          products.
        </p>
        <p>
          <strong>Phone Number:</strong> +66 2623 0491
        </p>
        <p>
          <strong>Email:</strong> {""}
          <a href="mailto:sales@proscope.co.th" style={{ color: "white" }}>
            sales@proscope.co.th
          </a>
        </p>
      </div>
      <div className="footer-bottom">
        <p>© 2026 PROSCOPE CO., LTD. - ALL RIGHTS RESERVED</p>
        {contactPopup.show && (
          <div className="contact-popup-overlay">
            <div className="contact-popup-modal">
              <h3>{contactPopup.title}</h3>

              <p>{contactPopup.message}</p>

              <div className="contact-popup-actions">
                <button
                  type="button"
                  className={`contact-popup-btn ${
                    contactPopup.type === "success" ? "success" : "error"
                  }`}
                  onClick={closeContactPopup}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
